type LastUsedMap = Record<string, number>;

const readLastUsedMap = (storageKey: string): LastUsedMap => {
  try {
    const rawValue = localStorage.getItem(storageKey);
    if (!rawValue) return {};

    const parsed = JSON.parse(rawValue) as LastUsedMap;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const writeLastUsedMap = (storageKey: string, lastUsedMap: LastUsedMap) => {
  localStorage.setItem(storageKey, JSON.stringify(lastUsedMap));
};

export const markItemsAsLastUsed = (storageKey: string, itemKeys: string[]) => {
  if (itemKeys.length === 0) return;

  const lastUsedMap = readLastUsedMap(storageKey);
  const now = Date.now();

  for (const [index, itemKey] of itemKeys.entries()) {
    lastUsedMap[itemKey] = now - index;
  }

  writeLastUsedMap(storageKey, lastUsedMap);
};

export const sortItemsByLastUsed = <T>(items: T[], storageKey: string, getItemKey: (item: T) => string, getFallbackLabel: (item: T) => string) => {
  const lastUsedMap = readLastUsedMap(storageKey);

  return items.toSorted((left, right) => {
    const leftLastUsed = lastUsedMap[getItemKey(left)] ?? 0;
    const rightLastUsed = lastUsedMap[getItemKey(right)] ?? 0;

    return leftLastUsed === rightLastUsed ? getFallbackLabel(left).localeCompare(getFallbackLabel(right)) : rightLastUsed - leftLastUsed;
  });
};
